import { Component, OnInit } from '@angular/core';
import { SESSION_TYPE, SessionService } from '../../services/session.service';
import * as moment from 'moment';
import { LogoutService } from '../../services/logout.service';

@Component({
     selector: 'app-connected-user',
     templateUrl: './connected-user.component.html',
     styleUrls: ['./connected-user.component.scss'],
})
export class ConnectedUserComponent implements OnInit {
     user = {} as any;
     type: SESSION_TYPE;
     isMorning = false;

     constructor(
          private session: SessionService,
          private logoutService: LogoutService
     ) {
          if (!window.app.tvScreen) {
               this.user = session.get();
               this.type = session.connectionType;
          }
          const currentHour = moment().get('hour');
          this.isMorning = currentHour >= 6 && currentHour <= 19;
     }

     ngOnInit() {}

     logout() {
          this.logoutService.run();
     }
}
